<app-layout>
  <router-outlet content></router-outlet>
</app-layout>
